import React from 'react'
import DarkMode from '../../../components/Authentication/DarkMode'
import SignUpForm from '../../../components/Authentication/SignUpForm'

const SignUp: React.FC = () => {
  return (
    <>
      <DarkMode />
      <SignUpForm />
    </>
  )
}

export default SignUp

